import { render } from "./TrendingModal.vue?vue&type=template&id=20761b37&scoped=true"
import script from "./TrendingModal.vue?vue&type=script&lang=js"
export * from "./TrendingModal.vue?vue&type=script&lang=js"

import "./TrendingModal.vue?vue&type=style&index=0&id=20761b37&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20761b37"]])

export default __exports__